import React from "react";
import { Navigate, Outlet } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import * as tokenConfig from "../../utils/tokenConfig";
import * as authActions from "../../redux/actions/authActions";

export default function ProtectedRoutes({ ...rest }) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  React.useEffect(() => {
    if (Boolean(tokenConfig.getToken() && tokenConfig.getUserdata())) {
      dispatch(authActions.loadAuthUser());
      console.log("in here");
      // dispatch(userActions.getUser());
    } else {
      dispatch(authActions.logout());
      console.log("logout");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return auth.isAuth ? <Outlet {...rest} /> : <Navigate to="/login" />;

  // return (
  //   <Route
  //     {...rest}
  //     render={(props) => {
  //       if (auth.isAuth) {
  //         return <Component {...rest} {...props} />;
  //       } else {
  //         return (
  //           <Redirect
  //             to={{
  //               pathname: "/login",
  //               state: {
  //                 from: props.location,
  //               },
  //             }}
  //           />
  //         );
  //       }
  //     }}
  //   />
  // );
}
